import rich from './rich/index.js'
import * as d3 from 'd3-selection'
import native from './native.js'
import defaults from './defaults.js'
import menuOptions from './menu-options.js'
import nativeState from './native-state.js'
import * as interactions from './rich/interactions.js'
import { EventEmitter } from 'events'

export default function (selection, opts) {

  function draw (control, data) {
    return control.datum(data)
                  .call(rich)
  }

  // Mix in the latest options to the data
  function getData (control, opts, i) {
    var data = control.datum()

    if (!data) {
      data = new EventEmitter

      data.on('change:open', function () {
        data.menuOptions = menuOptions(data, control, true)
        draw(control, data)
      })

      data.on('change:selected', function () {
        data.menuOptions = menuOptions(data, control, true)

        // Make sure the textarea was cleared if it's not a combo box
        data._clearInput = !data.combo

        draw(control.call(native, true), data) // Updates the native control, firing change events, then redraws the rich select.
      })

      data.on('create:tag', function (tag) {
        data.onCreate.call(control, tag)
      })

      data.on('change:search-term', function () {
        data._searchChange = true
        if (data.onSearch) {
          // This gives someone the ability to totally override menu options based on a search term
          data.onSearch.call(control, data.searchTerm)
        } else {
          // Since they just typed in a new keyword, remove the previously highlighted option
          data.options.forEach(function (d) {
            d.highlighted = false
          })
          if (data.combo) {
            // Combo select, and we know they just typed, clear the previously selected and/or highlighted option
            data.options.forEach(function (d) {
                          d.selected = false
                        })
          }

          // Redefine the menuOptions
          data.menuOptions = menuOptions(data, control, true)

          draw(control, data)

          if (data.combo){
            // We only need to update the native select if this search term was fired on a combo select.
            // Otherwise the value wouldn't have changed. Combo selects still need to update the native select
            // so the select's value (i.e. the placeholder selected option) matches what is typed in the textarea (input) box.
            control.call(native, data.combo)
          }

          delete data._searchChange
        }
      })
    }

    data._refreshOptions = true

    return defaults(data, control, opts, i)
  }

  selection.each(function (d, i) {
    var control = d3.select(this)
      , data = getData(control, opts, i)

    var onchange = this.onchange
      , update = function (value) {
        // TODO Handle multiple
        data.options.forEach(function (option) {
          option.selected = option[data.accessors.value] == value
        })
        draw(control, data)
      }
    // Hooks into native change event, so if it fires, we update the
    // rich select automagically
    this.onchange = function (e) {
      if (typeof onchange === 'function') {
        onchange.apply(this, arguments)
      }
      if (!e._rich) {
        update(this.value)
      }
    }

    // Internal hook to manually trigger a change event on the rich
    // select indicating the native value changed. Used to update
    // the rich select value w/o a native change event firing on the native
    // select
    control.on('change:rich', function (e) {
      /*
       * Combo selects are slightly more difficult because a user cannot set the value
       * of the native select to some arbitrary value. The browser won't respect the setting
       * if the select doesn't have that option. If a user wants to programmatically set
       * the value of a combo select, they can fire a change:rich event and pass `detail.value`
       */
      if (data.combo && e && e.detail && typeof e.detail.value !== 'undefined') {
        // Simulate a change:searchTerm event
        data.searchTerm = e.detail.value
        data.emit('change:search-term')
        return
      }

      var ns = nativeState(d3.select(this))
      data.disabled = ns.disabled
      data.multiple = ns.multiple
      update(this.value)
    })

    draw(control, data).call(native)

    // Open the menu by default if open flag sent
    if (opts.open) {
      interactions.open(data)
    }

    // Closes the menu if they explicitly set `false
    if (opts.open === false) {
      interactions.close(data)
    }
  })
}
